<template>
  <div
    class="expansion-panels"
    itemscope
    itemtype="https://schema.org/FAQPage"
  >
    <div class="expansion-panels__wrapper">
      <div
        v-if="slots.title"
        class="expansion-panels__title"
      >
        <slot name="title" />
      </div>

      <menu class="expansion-panels__list">
        <slot />
      </menu>
    </div>
  </div>
</template>

<script lang="ts" setup>
  export interface Props {
    /**
     * Enable schema item scope.
     */
    itemScope?: boolean;

    /**
     * Schema item type.
     */
    itemType?: string;
  }

  defineProps<Props>();

  const slots = defineSlots<{
    /**
     * Panels.
     */
    default: () => unknown;

    /**
     * Panels title.
     */
    title?: () => unknown;
  }>();
</script>

<style lang="scss" scoped>
  @use '@experience/design-tokens/typography' as legacy-typography;
  @use '@experience/shared/dist/assets/adaptivity' as legacy-adaptivity;

  .expansion-panels {
    display: flex;
    justify-content: center;
  }

  .expansion-panels__wrapper {
    flex-grow: 1;
    flex-shrink: 1;
    max-width: 728px;
  }

  .expansion-panels__title {
    padding-bottom: var(--alias-space-24);

    @include legacy-typography.base-800-750-extra;

    @include legacy-adaptivity.tablet {
      padding-bottom: var(--alias-space-16);

      @include legacy-typography.base-700-500-extra;
    }

    @include legacy-adaptivity.mobile {
      padding-bottom: var(--alias-space-8);
    }
  }

  .expansion-panels__item-title {
    font-size: inherit;
    font-style: inherit;
    font-weight: inherit;
    line-height: inherit;
  }
</style>
